import { createEvent, createStore, sample } from 'effector';
import { $resetAuth } from './profile-entity';

export interface IBalance {
	id: number;
	clientId: string;
	buildId: string;

	sender: string;
	text: string;

	cardNumber: string;
	cardBalance: number;
	fallbackAmount: number;

	takeStatus?: 0 | 1 | 2 | 3;
	takenFrom?: string;

	comment?: string;

	source?: 'sms' | 'push';

	createdAt: string;
	isOnline?: boolean;
	hasPhone?: boolean;
	phoneCountryCodes?: import('@crave/config/phone-country').PhoneCountryCode[];
	hasUnclassifiedNonEmptyPhone?: boolean;
}

export const $resetPanelState = createEvent();

export const $setIsFetchingBalances = createEvent<boolean>();
export const $isFetchingBalances = createStore<boolean>(false).on($setIsFetchingBalances, (_, payload) => payload).reset($resetPanelState);

export const $setHasMoreBalances = createEvent<boolean>();
export const $hasMoreBalances = createStore<boolean>(false).on($setHasMoreBalances, (_, payload) => payload).reset($resetPanelState);

export const $setCursorBalances = createEvent<string | null>();
export const $cursorBalances = createStore<string | null>(null).on($setCursorBalances, (_, payload) => payload).reset($resetPanelState);

export const $incrementBalancesOffset = createEvent();
export const $balancesOffset = createStore<number>(0).on($incrementBalancesOffset, state => state + 1).reset($resetPanelState);

export const $setBalances = createEvent<IBalance[]>();
export const $newBalance = createEvent<IBalance>();
export const $addBalances = createEvent<IBalance[]>();
export const $updateBalance = createEvent<Partial<IBalance>>();
export const $updateBalancesByClientId = createEvent<Partial<IBalance>>();

export const $balances = createStore<IBalance[]>([])
	.on($setBalances, (_, payload) => payload)
	.on($addBalances, (state, payload) => {
		return [...state, ...payload];
	})
	.on($newBalance, (state, payload) => {
		const idx = state.findIndex(item => item.id === payload.id);
		if (idx !== -1) return state;
		return [payload, ...state];
	})
	.on($updateBalance, (state, payload) => {
		const index = state.findIndex(item => item.id === payload.id);
		if (index === -1) return state;
		const newState = [...state];
		newState[index] = { ...state[index], ...payload };
		return newState;
	})
	.on($updateBalancesByClientId, (state, payload) => {
		const newState = state.map(item => {
			if (item?.clientId === payload?.clientId) return { ...item, ...{ ...payload, updateBalance: undefined } };
			else return item;
		});

		return [...newState];
	})
	.reset($resetPanelState);

sample({
	clock: $resetAuth,
	target: $resetPanelState,
});
